
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 試験会場管理
              <div class="card-header-actions">
                <CLink :href="'/place/import'" > CSVインポート</CLink>
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" color="info" @click="showRecordModal({country:'日本'}, 0, 'Create')">新規作成</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="2">
                </CCol>
                <CCol sm="4">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="都道府県"
                    :options="region"
                    v-model="select_place"
                    @update:value="search"
                    name="state"
                  />
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="業種"
                    :options="industryTypes"
                    v-model="select_industry"
                    @update:value="search"
                    name="industry_id"
                  />
                </CCol>
              </CRow>


              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :fields="fields"
                :tableFilter="true"
                sorter
                @update:sorter-value="sort"
                @update:table-filter-value="search"
                itemsPerPage="30"
                pagination
              >
                <template #industry_id="{item}">
                  <td> {{ industries[item.industry_id] }}</td>
                </template>
                <template #name="{item}">
                  <td> {{item.place_id}}</td>
                </template>
                <template #name="{item}">
                  <td> {{item.name}}</td>
                </template>
                <template #created_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>

                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>


              </CDataTable>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">試験の業種</label>
           <CSelect
             placeholder="問題の業種を選択してください"
             :class="{ 'hasError': $v.record.industry_id.$error }"
             :options="industryTypes"
             :value.sync="record.industry_id"
           />

           <small v-if="$v.record.industry_id.$error" class="errorLabel">業種名を入れてください</small>
         </CCol>


         <CCol sm="12">
           <label class="record-label pt-3">会場名</label>
           <CInput
             placeholder="〜〜センター"
             v-model="record.name"
             :class="{ 'hasError': $v.record.name.$error }"
             required
           />
           <small v-if="$v.record.name.$error" class="errorLabel">会場名を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">会場番号</label>
           <CInput placeholder="会場番号" v-model="record.place_id" />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">郵便番号</label>
           <CInput placeholder="郵便番号" v-model="record.zip" :class="{ 'hasError': $v.record.zip.$error }"/>
           <small v-if="$v.record.name.$error" class="errorLabel">郵便番号を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">国</label>
           <CInput placeholder="" v-model="record.country" :class="{ 'hasError': $v.record.country.$error }"/>
           <small v-if="$v.record.name.$error" class="errorLabel">国名をを入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">都道府県・州</label>
           <CInput v-if='record.country !=  "日本"' placeholder="" v-model="record.state" :class="{ 'hasError': $v.record.state.$error }"/>
           <CSelect
             v-else
             placeholder="問題の業種を選択してください"
             :class="{ 'hasError': $v.record.state.$error }"
             :options="region"
             :value.sync="record.state"
           />
           <small v-if="$v.record.name.$error" class="errorLabel">都道府県・週を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">住所</label>
           <CInput placeholder="" v-model="record.full_address" :class="{ 'hasError': $v.record.full_address.$error }"/>
           <small v-if="$v.record.name.$error" class="errorLabel">郵便番号を除く住所を入力してください(例: 東京都府中市テスト町1-1-11</small>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>
       </template>
    </CModal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
//TODO: ぱんくず

import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {
    Paginate
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'industry_id', label: "試験業種"},
        { key: 'place_id', label: "会場番号"},
        { key: 'name', label: "会場名"},
        { key: 'country', label: "国"},
        { key: 'full_address', label: "住所"},
        { key: 'created_at', label: "作成日"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}],
      recordModal: false,
      deleteModal: false,
      sort_column: "",
      sort_asc: "",
      industries: {},
      mode: "",
      username: '',
      password: '',
      word: '',
      itemIndex: 0,
      meta: {},
      page: 1,
      select_industry: "",
      select_place: '',
      industryTypes: [] ,
      filter_cs: [],
      filter_vs: [],
      record: {
        name: "",
        description: ""
      },
      region: [
        '',
        '北海道',
        '青森',
        '岩手',
        '宮城',
        '秋田',
        '山形',
        '福島',
        '茨城',
        '栃木',
        '群馬',
        '埼玉',
        '千葉',
        '東京',
        '神奈川',
        '新潟',
        "富山",
        '石川',
        '福井',
        '山梨',
        '長野',
        '岐阜',
        '静岡',
        '愛知',
        '三重',
        '滋賀',
        '京都',
        '大阪',
        '兵庫',
        '奈良',
        '和歌山',
        '鳥取',
        '島根',
        '岡山',
        '広島',
        '山口',
        '徳島',
        '香川',
        '愛媛',
        '高知',
        '福岡',
        '佐賀',
        "長崎",
        '熊本',
        '大分',
        '宮崎',
        '鹿児島',
        '沖縄',
      ]
    }
  },
  validations: {
    record: {
      name: {required},
      zip: {required},
      country: {required},
      state: {required},
      full_address: {required},
      industry_id: {required},
    }
  },
  methods: {
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          console.log(result)
          this.$router.replace('/home')
        })
        .then(err => {
          this.error = err
        })
    },
    sort: function(e) {
      this.sort_column = e.column
      this.sort_asc = (e.asc == true)? "asc" : "desc"
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/places?word=" + this.word + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(","), {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.items = response.data.places
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/places?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.items = response.data.places
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    search: function(e, c) {
      this.word = e
      if(c != undefined){
        this.filter_update(c.target.name, e)
      }
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/places?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.items = response.data.places
          this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    filter_update: function(k, v) {
      if(this.filter_cs.includes(k)) {
        var i = this.filter_cs.indexOf(k)
        if(v == "-") {
          this.filter_cs.splice(i, 1)
          this.filter_vs.splice(i, 1)
        } else {
          this.filter_cs[i] = k
          this.filter_vs[i] = v
        }
      } else {
        this.filter_cs.push(k)
        this.filter_vs.push(v)
      }
    },
    formatDate: function(d) {
      return moment(d).format("YYYY/MM/DD HH:mm")
    },
    validator (val) {
      return val ? val.length >= 1 : false
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規会場追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      this.record = i

      this.mode = mode
      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    updateItem: function(mode="Create", index=0) {
      this.$v.record.$touch();
      if(this.$v.record.$error) return

      if(mode == "Create") {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/places", {"place": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            this.items.push(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/places/" + this.record.id, {"place": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.recordModal = false
            this.items[index] = this.record
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/places/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.items.splice(this.itemIndex, 1)
          this.hideDeleteModal()
        }).catch(error => {
          this.errorNotify(error.response)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/places", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.items = response.data.places
          this.meta = response.data.meta
      }).catch(error => {
          this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
